import React from 'react';
import { Wrapper } from '../Wrapper';
import { FeatureTableSectionProps } from './FeatureTableSectionBase';

const FeatureTableSectionBase = React.lazy(
    () => import('./FeatureTableSectionBase')
);

export const FeatureTableSection = Wrapper(
    (p: FeatureTableSectionProps): JSX.Element => {
        return (
            <React.Suspense fallback={null}>
                <FeatureTableSectionBase {...p} />
            </React.Suspense>
        );
    },
    'featureTableSection'
);
